'use client'

import If from '~/core/ui/If'
import { cn } from '~/core/ui/utils'

export type ChipSecondaryLabelProps = {
  label?: string | null
  className?: string
  separatorClassName?: string
}

/**
 * Shared chip meta (e.g. skill level): gray dot + secondary text.
 * Used by SuggestionChips and skill chips in the candidate profile.
 */
const ChipSecondaryLabel = ({
  label,
  className,
  separatorClassName
}: ChipSecondaryLabelProps) => {
  return (
    <If condition={!!label}>
      <div className={cn('mx-1 h-0.5 w-0.5 shrink-0 bg-gray-400', separatorClassName)} />
      <div className={cn('text-xs text-gray-500', className)}>{label}</div>
    </If>
  )
}

export default ChipSecondaryLabel
